import { CMLUtils } from '@coursera-web/cml';
import type { CmlContent } from '@coursera-web/cml';

import Feedback from './Feedback';

class LikeFeedback extends Feedback {
  constructor(value: number, active: boolean, comment?: CmlContent) {
    const maxValue = 1;

    const feedback = {
      rating: { value, maxValue, active },

      comments: {
        generic: comment || CMLUtils.create(''),
      },
    };

    super(feedback);
  }

  get isLike() {
    return this.value === 1;
  }

  get isDislike() {
    return this.value === 0;
  }

  get isSelected() {
    return this.isActive;
  }

  get comment() {
    return this.comments && this.comments.generic;
  }
}

export default LikeFeedback;
